import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{html-safe this.text}}",{ moduleName: "discourse/components/text-overflow.hbs" })